var map = {
	"./LIGHTer_logo.svg": 1278,
	"./Lighter_logo.png": 303,
	"./article/article_person01.jpg": 8548,
	"./article/cecilia.jpg": 4079,
	"./article/lightbox_fn_large_ENG.png": 3161,
	"./article/lightbox_fn_large_SE.png": 7627,
	"./article/lightbox_fn_small_ENG.jpg": 5439,
	"./article/lightbox_fn_small_SE.jpg": 1005,
	"./article/lightbox_innovation_large_ENG.jpg": 9962,
	"./article/lightbox_innovation_large_SE.jpg": 466,
	"./article/lightbox_innovation_small_ENG.jpg": 1255,
	"./article/lightbox_innovation_small_SE.jpg": 5392,
	"./article/lightbox_step_large_ENG.jpg": 6811,
	"./article/lightbox_step_large_SE.jpg": 8662,
	"./article/lightbox_step_small_ENG.jpg": 8639,
	"./article/lightbox_step_small_SE.jpg": 4381,
	"./back.svg": 1650,
	"./bgs/bg_parallax_clouds.jpg": 9105,
	"./bgs/bg_parallax_intro.png": 1684,
	"./bgs/bg_parallax_quote.jpg": 9484,
	"./bgs/bg_parallax_recommend.png": 3209,
	"./bgs/wheel_intro.jpg": 7308,
	"./lang_black.svg": 6160,
	"./lang_icon.svg": 71,
	"./map_bg.png": 7281,
	"./menu_open.svg": 5021,
	"./mission.svg": 7421,
	"./partners/01_eu.jpg": 9165,
	"./partners/footer_logos_EN.png": 9390,
	"./partners/footer_logos_SV.png": 151,
	"./partners/rise_logo.png": 6929,
	"./structure/close.svg": 3411,
	"./structure/hero_scroll_arrow.svg": 6367,
	"./structure/link_blank.svg": 7411,
	"./structure/menu_close.svg": 281,
	"./structure/menu_open.svg": 9093,
	"./structure/play_btn.svg": 5323,
	"./structure/zoom.svg": 9007,
	"./up.svg": 2887,
	"./vision.svg": 12,
	"./wheel/arrow_w_text_ENG.svg": 6876,
	"./wheel/arrow_w_text_SE.svg": 725,
	"./wheel/cover.svg": 2057,
	"./wheel/design_arrow.svg": 7575,
	"./wheel/icon_00.svg": 5059,
	"./wheel/icon_01.svg": 3694,
	"./wheel/icon_02.svg": 1682,
	"./wheel/icon_03.svg": 4806,
	"./wheel/icon_04.svg": 5763,
	"./wheel/icon_05.svg": 7692,
	"./wheel/icon_06.svg": 3409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;